import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { NoQeMetricsErrorIcon, QeScoreLoadErrorIcon } from './QeErrorIcons';
import { useStyles } from '../../styles';
import CONSTANTS from '../../../constants';
import { ERROR_TYPE } from '../../constants';

const { QESCORE_CONTACT_EMAIL: CONTACT_EMAIL } = CONSTANTS.QESCORE;

export function QeScoreLoadError({ errorType }: { errorType?: string }) {
  const classes = useStyles();
  const theme = useTheme();
  const isNoQeMetricsError = errorType === ERROR_TYPE.NO_QE_METRICS;
  const isDark = theme.palette.type === 'dark';

  const renderErrorIcon = () => {
    if (isNoQeMetricsError) {
      return <NoQeMetricsErrorIcon isDark={isDark} fontSize="large" />;
    } else return <QeScoreLoadErrorIcon isDark={isDark} fontSize="large" />;
  };

  const renderErrorBody = () => {
    return (
      <>
        <Typography variant="h6" className={classes.notApplicableTitle}>
          {isNoQeMetricsError
            ? 'Error: Unable to process request'
            : 'An error occurred while fetching QE Score data.'}
        </Typography>

        <div className={classes.notApplicableDivider} />

        <Typography variant="body2" className={classes.notApplicableBody}>
          {isNoQeMetricsError
            ? 'This may be due to a missing project mapping or another configuration issue'
            : ' Please refresh the page or try again later. If the issue persists,'}
        </Typography>

        <Typography variant="body2" className={classes.notApplicableBody}>
          Please reach out to{' '}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className={classes.notApplicableLink}
          >
            {CONTACT_EMAIL}
          </a>{' '}
          or teams channel{' '}
          <a
            href={CONSTANTS.QESCORE.QESCORE_TEAMS_CHANNEL}
            className={classes.notApplicableLink}
            target="_blank"
            rel="noreferrer"
          >
            Quality Engineering
          </a>
        </Typography>
      </>
    );
  };

  return (
    <div className={classes.notApplicableRoot}>
      <div className={classes.notApplicableIconWrapper}>
        {renderErrorIcon()}
      </div>

      {renderErrorBody()}
    </div>
  );
}
